// ACA-344: the way out to /login, below each pre-account step's primary action.
export function LogInPrompt() {
  return (
    <p className="onboarding-v2__login" data-testid="onboarding-v2-login">
      <span>Already have an account?</span>
      <a href="/login">Log in</a>
    </p>
  );
}
